<template>
  <v-dialog
    v-model="dialog"
    max-width="350"
  >
    <v-card>
      <v-card-title>
        {{ $t('Components.Dialogs.ChangePassword.Title') }}
        <v-spacer />
        <v-icon
          aria-label="Close"
          @click="$emit('close',false)"
        >
          mdi-close
        </v-icon>
      </v-card-title>
      <v-form ref="form">
        <v-card-text>
          <v-text-field
            v-model="oldPassword"
            :label="$t('Components.Dialogs.ChangePassword.Labels.OldPassword')"
            class="purple-input"
            type="password"
            :rules="[oldValidation]"
          />
          <v-text-field
            v-model="newPassword"
            :label="$t('Components.Dialogs.ChangePassword.Labels.NewPassword')"
            class="purple-input"
            type="password"
            :rules="[newPasswordValidation]"
          />
          <v-text-field
            v-model="confirmPassword"
            :label="$t('Components.Dialogs.ChangePassword.Labels.ConfirmPassword')"
            class="purple-input"
            type="password"
            :rules="[confirmValidation]"
          />
        </v-card-text>
        <v-card-text class="pb-6 pt-12 text-center">
          <v-btn
            class="mr-3"
            text
            @click.stop="$emit('close',false)"
          >
            {{ $t('General.Buttons.Close') }}
          </v-btn>

          <debounce-v-btn
            color="success"
            text
            @click="changePassword()"
          >
            {{ $t('General.Buttons.Submit') }}
          </debounce-v-btn>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import UserProfileService from '@/services/userProfileService'
  import validation from '@/helpers/validationHelper'

  export default {
    name: 'ChangePasswordDialog',
    props: {
      visible: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    data: () => ({
      dialog: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      badRequestReasons: {},
    }),
    computed: {
    },
    watch: {
      visible: function () {
        this.dialog = this.visible
      },
      dialog: function (value) {
        if (!value) {
          this.reset()
          this.$emit('close', false)
        }
      },
    },
    mounted: function () {
    },
    methods: {
      reset () {
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmPassword = ''
        this.badRequestReasons = {}
      },
      async changePassword () {
        this.badRequestReasons = {}
        if (this.$refs.form.validate() !== true) {
          return
        }

        var loadingId = await this.$store.dispatch('AddLoadingMessage', this.$t('Components.Dialogs.ChangePassword.Messages.SubmitLoadMessage'))
        var result = await UserProfileService.ChangePassword(this.oldPassword, this.newPassword, this.confirmPassword)
        this.$store.dispatch('RemoveLoadingMessage', loadingId)

        if (result.success === true) {
          await this.$store.dispatch('SetSnackBarMessage', {
            message: this.$t('Components.Dialogs.ChangePassword.Messages.Success'),
            color: 'success',
          })
          this.$emit('close', true)
        }
        this.badRequestReasons = result.badRequestReasons
        // trigger the rules so the api errors are shown
        this.$refs.form.validate()
      },
      newPasswordValidation (value) {
        if (validation.stringIsNotNullOrWhitespace(value) !== true) {
          return this.$t('Components.Dialogs.ChangePassword.Validation.RequiredPassword')
        }
        if (this.badRequestReasons.newPassword) {
          return this.$t('Components.Dialogs.ChangePassword.Validation.BadRequestReasons.' + this.badRequestReasons.newPassword[0])
        }
        return true
      },
      confirmValidation (value) {
        if (validation.stringIsNotNullOrWhitespace(value) !== true) {
          return this.$t('Components.Dialogs.ChangePassword.Validation.RequiredConfirmPassword')
        }
        if (value !== this.newPassword) {
          return this.$t('Components.Dialogs.ChangePassword.Validation.PasswordMismatch')
        }
        return true
      },
      oldValidation (value) {
        if (validation.stringIsNotNullOrWhitespace(value) !== true) {
          return this.$t('Components.Dialogs.ChangePassword.Validation.RequiredOldPassword')
        }
        if (this.badRequestReasons.oldPassword) {
          return this.$t('Components.Dialogs.ChangePassword.Validation.BadRequestReasons.' + this.badRequestReasons.oldPassword[0])
        }
        return true
      },
    },
  }
</script>

<style lang="scss">
</style>
